export default "__VITE_ASSET__DpOam8kY__"